import { publish } from 'ert-framebus';
import { PubSubMessages } from '../../../config';
import { NavigationOptions, NavigationService, State, Project } from 'navigator-header';

export class NavigationServiceImpl implements NavigationService {

    navigateTo(clientId: string, state: string | State, options: NavigationOptions = {}): Promise<any> {
        return new Promise((resolve, reject) => {
            publish(PubSubMessages.navigationServiceNavigateTo, clientId, state, options, resolve, reject);
        });
    }

    navigateToStudy(project: Project, sqfPin?: string, destinationUrl?: string): void {
        publish(PubSubMessages.navigateToStudy, project, sqfPin, destinationUrl);
    }

    navigateByUseCase(clientId: string, useCase: string, data?: object, project?: Project, options: NavigationOptions = {}): Promise<any> {
        return new Promise((resolve, reject) => {
            publish(PubSubMessages.redirect, clientId, useCase, data, project, options, resolve, reject);
        });
    }

    getSelectedStudy(): Promise<Project | null> {
        return new Promise((resolve) => {
            publish(PubSubMessages.getSelectedStudy, resolve);
        });
    }
}